import React, { useEffect } from 'react'
import { initializeMixpanel } from './mixPanel'
import App from './App';

const Main = () => {
    useEffect(() => {
        initializeMixpanel();
    }, [])
    return (
        <>
            <App />
        </>
    )
}

export default Main